<ng-container [ngSwitch]="view.mode">

    <!-- 1a  Upgrade pop-up (during the trial; closable) -->
    <div *ngSwitchCase="'upgrade'" class="bg-overlay">
        <div class="bg-dialog bg-dialog--480" role="dialog" aria-modal="true" aria-labelledby="vfBillingUpgradeTitle">
            <div class="bg-upgrade-head">
                <div class="bg-upgrade-titles">
                    <span id="vfBillingUpgradeTitle" class="bg-upgrade-title">Upgrade Trovve</span>
                    <span class="bg-upgrade-sub" *ngIf="view.trialLine">{{ view.trialLine }}</span>
                </div>
                <button type="button" class="bg-close" aria-label="Close" (click)="close()">
                    <lucide-icon name="x" [size]="16" class="no-fill"></lucide-icon>
                </button>
            </div>
            <div class="bg-main">
                <vf-plan-picker *ngIf="view.hasPrices" variant="full" [plans]="status.plans" [teamSize]="status.teamSize"
                    [maxPeople]="status.maxPeople" [yearlySavingsPerPerson]="status.yearlySavingsPerPerson"
                    (selectionChange)="onSelection($event)">
                    <button type="button" class="bg-btn bg-btn--primary" [disabled]="paying" (click)="continueToPayment()">Continue to payment</button>
                    <span class="bg-secure"><lucide-icon name="lock" [size]="12" class="no-fill"></lucide-icon>Plus applicable tax. Secure payment by Stripe. Cancel anytime.</span>
                </vf-plan-picker>
                <p class="bg-noprices" *ngIf="!view.hasPrices">Prices are not available right now. Please try again in a few minutes.</p>
            </div>
        </div>
    </div>

    <!-- 1b / 1c / 1f  Blocking pop-up: the firm cannot use Trovve. No close, nothing behind it is usable. -->
    <div *ngSwitchCase="'blocked'" class="bg-overlay bg-overlay--block">

        <!-- 1b  Trial ended (admin) -->
        <div *ngIf="view.isAdmin && view.reason === 'trialEnded'" class="bg-dialog bg-dialog--480" role="dialog" aria-modal="true" aria-labelledby="vfBillingBlockTitle">
            <div class="bg-block-head">
                <span class="bg-icon bg-icon--amber"><lucide-icon name="clock" [size]="20" class="no-fill"></lucide-icon></span>
                <span id="vfBillingBlockTitle" class="bg-block-title">{{ view.title }}</span>
                <span class="bg-block-message">{{ view.message }}</span>
            </div>
            <div class="bg-main">
                <vf-plan-picker *ngIf="view.hasPrices" variant="blocked" [plans]="status.plans" [teamSize]="status.teamSize"
                    [maxPeople]="status.maxPeople" [yearlySavingsPerPerson]="status.yearlySavingsPerPerson"
                    (selectionChange)="onSelection($event)">
                    <button type="button" class="bg-btn bg-btn--primary" [disabled]="paying" (click)="continueToPayment()">Continue to payment</button>
                    <a class="bg-btn bg-btn--secondary" [href]="talkToUsHref">Talk to us</a>
                    <span class="bg-secure"><lucide-icon name="lock" [size]="12" class="no-fill"></lucide-icon>Plus applicable tax. Secure payment by Stripe. Cancel anytime.</span>
                </vf-plan-picker>
                <ng-container *ngIf="!view.hasPrices">
                    <p class="bg-noprices">Prices are not available right now. Please try again in a few minutes.</p>
                    <a class="bg-btn bg-btn--secondary" [href]="talkToUsHref">Talk to us</a>
                </ng-container>
            </div>
        </div>

        <!-- 1f  Subscription has ended (admin) -->
        <div *ngIf="view.isAdmin && view.reason === 'ended'" class="bg-dialog bg-dialog--392 bg-dialog--compact" role="dialog" aria-modal="true" aria-labelledby="vfBillingEndedTitle">
            <div class="bg-compact-head">
                <span class="bg-icon bg-icon--sm bg-icon--grey"><lucide-icon name="calendar" [size]="19" class="no-fill"></lucide-icon></span>
                <span id="vfBillingEndedTitle" class="bg-compact-title">{{ view.title }}</span>
                <span class="bg-compact-message">{{ view.message }}</span>
            </div>
            <vf-plan-picker *ngIf="view.hasPrices" variant="compact" [plans]="status.plans" [teamSize]="status.teamSize"
                [maxPeople]="status.maxPeople" [yearlySavingsPerPerson]="status.yearlySavingsPerPerson"
                (selectionChange)="onSelection($event)">
                <button type="button" class="bg-btn bg-btn--primary bg-btn--compact" [disabled]="paying" (click)="continueToPayment()">Continue to payment</button>
                <span class="bg-secure bg-secure--compact"><lucide-icon name="lock" [size]="12" class="no-fill"></lucide-icon>Plus applicable tax. Secure payment by Stripe.</span>
            </vf-plan-picker>
            <ng-container *ngIf="!view.hasPrices">
                <p class="bg-noprices">Prices are not available right now. Please try again in a few minutes.</p>
                <a class="bg-btn bg-btn--secondary bg-btn--compact" [href]="talkToUsHref">Talk to us</a>
            </ng-container>
        </div>

        <!-- 1f  Subscription is paused (admin) -->
        <div *ngIf="view.isAdmin && view.reason === 'paused'" class="bg-dialog bg-dialog--392 bg-dialog--compact" role="dialog" aria-modal="true" aria-labelledby="vfBillingPausedTitle">
            <div class="bg-compact-head">
                <span class="bg-icon bg-icon--sm bg-icon--red"><lucide-icon name="credit-card" [size]="19" class="no-fill"></lucide-icon></span>
                <span id="vfBillingPausedTitle" class="bg-compact-title">{{ view.title }}</span>
                <span class="bg-compact-message">{{ view.message }}</span>
            </div>
            <div class="bg-card-row">
                <span class="bg-card-icon"><lucide-icon name="credit-card" [size]="16" class="no-fill"></lucide-icon></span>
                <span class="bg-card-text">
                    <span class="bg-card-name">{{ view.cardLine }}</span>
                    <span class="bg-card-declined">{{ view.declinedLine }}</span>
                </span>
                <span class="bg-card-due" *ngIf="view.dueLine">{{ view.dueLine }}</span>
            </div>
            <button type="button" class="bg-btn bg-btn--primary bg-btn--compact" [disabled]="openingPortal" (click)="updateCard()">Update card</button>
            <a class="bg-btn bg-btn--secondary bg-btn--compact-secondary" [href]="talkToUsHref">Talk to us</a>
            <span class="bg-secure bg-secure--compact"><lucide-icon name="lock" [size]="12" class="no-fill"></lucide-icon>Plus applicable tax. Secure payment by Stripe.</span>
        </div>

        <!-- 1c  Team member (any reason): no prices, ask the admin -->
        <div *ngIf="!view.isAdmin" class="bg-dialog bg-dialog--440 bg-dialog--member" role="dialog" aria-modal="true" aria-labelledby="vfBillingMemberTitle">
            <div class="bg-member-head">
                <span class="bg-icon" [class.bg-icon--amber]="view.iconTone === 'amber'" [class.bg-icon--red]="view.iconTone === 'red'"
                    [class.bg-icon--grey]="view.iconTone === 'grey'"><lucide-icon [name]="view.icon" [size]="20" class="no-fill"></lucide-icon></span>
                <span id="vfBillingMemberTitle" class="bg-block-title">{{ view.title }}</span>
                <span class="bg-block-message">{{ view.message }}</span>
            </div>
            <div class="bg-owner">
                <img *ngIf="view.ownerPicture" class="bg-owner-avatar" [src]="view.ownerPicture" alt="">
                <span *ngIf="!view.ownerPicture" class="bg-owner-avatar bg-owner-avatar--initials">{{ view.ownerInitials }}</span>
                <span class="bg-owner-text">
                    <span class="bg-owner-name">{{ view.ownerName }}</span>
                    <span class="bg-owner-role">Admin</span>
                </span>
            </div>
            <button *ngIf="!view.askSent" type="button" class="bg-btn bg-btn--primary" [disabled]="asking" (click)="askAdmin()">Ask admin to upgrade</button>
            <span *ngIf="view.askSent" class="bg-sent" role="status">
                <lucide-icon name="check" [size]="15" class="no-fill"></lucide-icon>{{ view.askSentLabel }}
            </span>
        </div>
    </div>

    <!-- Settings → Billing → Change plan (story Part 6): the same plan cards; people follow the team -->
    <div *ngSwitchCase="'changePlan'" class="bg-overlay">
        <div class="bg-dialog bg-dialog--480" role="dialog" aria-modal="true" aria-labelledby="vfBillingChangeTitle">
            <div class="bg-upgrade-head">
                <div class="bg-upgrade-titles">
                    <span id="vfBillingChangeTitle" class="bg-upgrade-title">Change plan</span>
                    <span class="bg-upgrade-sub" *ngIf="changeView.currentLine">{{ changeView.currentLine }}</span>
                    <span class="bg-upgrade-sub" *ngIf="changeView.pendingLine">{{ changeView.pendingLine }}</span>
                </div>
                <button type="button" class="bg-close" aria-label="Close" (click)="close()">
                    <lucide-icon name="x" [size]="16" class="no-fill"></lucide-icon>
                </button>
            </div>
            <div class="bg-main">
                <p class="bg-noprices" *ngIf="changeView.reason">{{ changeView.reason }}</p>
                <vf-plan-picker *ngIf="changeOptions?.canChange" variant="blocked" [plans]="changeOptions.plans"
                    [teamSize]="changeOptions.people" [maxPeople]="changeOptions.people" [fixedPeople]="changeOptions.people"
                    [initialPlan]="changeOptions.currentPlan" [yearlySavingsPerPerson]="changeOptions.yearlySavingsPerPerson"
                    (selectionChange)="onChangeSelection($event)">
                    <button type="button" class="bg-btn bg-btn--primary" [disabled]="changing || changeView.buttonDisabled"
                        (click)="applyChangePlan()">{{ changeView.buttonLabel }}</button>
                    <span class="bg-secure" *ngIf="changeView.note">{{ changeView.note }}</span>
                </vf-plan-picker>
            </div>
        </div>
    </div>

    <!-- 1d  After Stripe payment -->
    <div *ngSwitchCase="'confirming'" class="bg-overlay">
        <div class="bg-dialog bg-dialog--420 bg-dialog--center" role="dialog" aria-modal="true" aria-labelledby="vfBillingConfirmTitle">
            <span class="bg-round bg-round--wait"><lucide-icon name="loader-circle" [size]="20" class="no-fill bg-spin"></lucide-icon></span>
            <span id="vfBillingConfirmTitle" class="bg-center-title">Confirming your payment</span>
            <span class="bg-center-text">This usually takes a few seconds. You can keep this window open.</span>
        </div>
    </div>

    <div *ngSwitchCase="'slow'" class="bg-overlay">
        <div class="bg-dialog bg-dialog--420 bg-dialog--center" role="dialog" aria-modal="true" aria-labelledby="vfBillingSlowTitle">
            <span class="bg-round bg-round--wait"><lucide-icon name="loader-circle" [size]="20" class="no-fill bg-spin"></lucide-icon></span>
            <span id="vfBillingSlowTitle" class="bg-center-title">Confirming your payment</span>
            <span class="bg-center-text">This is taking longer than usual. We’ll email you when it’s done.</span>
            <button type="button" class="bg-btn bg-btn--primary bg-btn--full" (click)="keepWorking()">Keep working</button>
        </div>
    </div>

    <div *ngSwitchCase="'done'" class="bg-overlay">
        <div class="bg-dialog bg-dialog--420 bg-dialog--center" role="dialog" aria-modal="true" aria-labelledby="vfBillingDoneTitle">
            <span class="bg-round bg-round--done"><lucide-icon name="check" [size]="20" class="no-fill"></lucide-icon></span>
            <span id="vfBillingDoneTitle" class="bg-center-title">You’re all set</span>
            <span class="bg-center-text">{{ view.doneSummary }}</span>
            <button type="button" class="bg-btn bg-btn--primary bg-btn--full" (click)="goToMyDay()">Go to My day</button>
        </div>
    </div>

</ng-container>
